export default {
    'OPERACION_CONTRATISTA': (state, mutation) => {
        state.contratista = mutation.contratista
    }
}